import { BaseTopMenuBloc } from "./bloc.base";

export class DemoTopMenuBloc extends BaseTopMenuBloc {

}

